export const STATUS = {
  OK: 1,
  CONSENT: 2,
  FAIL: 3,
}

export const ERROR_CODE = {
  FAIL_TO_GET_AUTHORIZATION_CODE: 113301,
  INVALID_REQUEST: 113913,
  INVALID_RESPONSE: 113914,
  IAC_INVALID_PLATFORM_TYPE: 113303,
  IAC_INVALID_CLIENT: 113304,
  IAC_INVALID_REDIRECT_URI: 113305,
  IAC_KRPC_MEMBER_ACCESS_CODE_NOT_EXIST: 113306,
  IAC_UNKNOWN_ERROR: 113307,
}

export const ERROR_NAME = {
  113301: 'fail_to_get_authorization_code',
  113303: 'IAC_INVALID_PLATFORM_TYPE',
  113304: 'IAC_INVALID_CLIENT',
  113305: 'IAC_INVALID_REDIRECT_URI',
  113306: 'IAC_KRPC_MEMBER_ACCESS_CODE_NOT_EXIST',
  113307: 'IAC_UNKNOWN_ERROR',
  113913: 'invalid_request',
  113914: 'invalid_response',
}

export const SERVER_ERROR_NAME = {
  NOT_FOUND_USER_CONSENT: 'IAC_NOT_FOUND_USER_SCOPE_CONSENT', // IAC#216
}
